export default __webpack_public_path__ + "static/media/marker-icon-grey.7481b288.svg";